import React, { useState } from "react";
import { PageTabs } from "@velaro/velaro-component-lib";
import NetSuiteDataMapping from "./NetSuiteDataMapping";
import IntegrationActivityLog from "../IntegrationActivityLog";

interface Props {
  teamId: number;
  selectedConfigId: number;
}

export default function NetsuiteTabs(props: Props) {
  const [activeTab, setActiveTab] = useState("Data Mapping");

  return (
    <div className="panel bg-white rounded-2xl shadow-md mb-4 p-6">
      <PageTabs
        tabs={["Data Mapping", "Logs"]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      <div className="pt-4">
        {activeTab === "Data Mapping" ? (
          <NetSuiteDataMapping
            teamId={props.teamId}
            selectedConfigId={props.selectedConfigId}
          />
        ) : (
          <IntegrationActivityLog integrationSlug="NetSuite" />
        )}
      </div>
    </div>
  );
}
